<template>
  <div>
    <!--BACKGROUOND OPACITY-->
    <div
      ref="backdrop"
      class="fade modal-backdrop"
      style="display: none;"
    ></div>

    <!--MODAL DIALOG-->
    <div
      ref="modal"
      class="modal fade"
      style="display: none;"
    >
      <div
        class="modal-dialog"
        :class="classes"
      >
        <div class="modal-content">
          <!--HEADER-->
          <div class="modal-header">
            <h5
              class="modal-title"
              v-text="data.title"
            ></h5>
            <button
              type="button"
              class="close"
              @click="close(-1)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!--BODY-->
          <div
            class="modal-body"
            v-html="data.body"
          ></div>

          <!--FOOTER-->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="close(1)"
              v-html="_trans('Ok')"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        components: {},
        props: {
            closeOnEsc: {type: Boolean, default: true},
            canClose: {type: Boolean, default: true},
            classes: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                response: {type: Object},
                data: {type: Object, default: {}}
            };
        },
        computed: {},
        created() {
            document.addEventListener("keyup", this.keyPressed);
            // document.getElementsByTagName('BODY').classList.add("modal-open");
        },
        mounted() {
            document.body.appendChild(this.$el);
            // this.$el.addEventListener('contextmenu', event => event.preventDefault());
        },
        beforeDestroy() {
            document.removeEventListener("keyup", this.keyPressed);
        },
        destroyed() {
            // Destroy DOM modal element
            if(this.$el && this.$el.parentNode)
              this.$el.parentNode.removeChild(this.$el);
            // this.$el.removeEventListener('contextmenu', event => event.preventDefault());
        },
        methods: {
            onShow() {
            },
            onClose() {
            },
            hide(afterTimeoutFunc) {
                document.body.classList.remove("modal-open");

                if (this.$refs.modal) this.$refs.modal.classList.remove("show");

                if (this.$refs.backdrop) this.$refs.backdrop.classList.remove("show");

                setTimeout(() => {
                    if (this.$refs.backdrop) this.$refs.backdrop.style.display = "none";

                    if (this.$refs.modal) this.$refs.modal.style.display = "none";

                    if (afterTimeoutFunc) afterTimeoutFunc();
                }, 150);
            },
            show() {
                document.body.classList.add("modal-open");
                if (this.$refs.backdrop) this.$refs.backdrop.style.display = "block";
                if (this.$refs.modal) this.$refs.modal.style.display = "block";
                setTimeout(() => {
                    if (this.$refs.modal) this.$refs.modal.classList.add("show");
                    if (this.$refs.backdrop) this.$refs.backdrop.classList.add("show");
                }, 0);
                this.onShow();
            },
            /** Use timeout callback function to close modal
             * @param mode
             */
            close(mode = -1) {
                this.hide(() => {
                    this.onClose();
                    this.$emit("close", mode, this.response);
                });
            },
            open(data = {title: "Title", body: "<p>Message</p>"}) {
                this.data = data;
                this.show();

                // Return object to handle event in one line
                return this;
            },
            keyPressed(e) {
                if (!e.code) return;

                switch (e.code.toLowerCase()) {
                    case "escape":
                        if (this.canClose && this.closeOnEsc) this.close();
                        break;
                }
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/configurator/dialogs/_baseModal.vue